<h3 class="mt-3">Eventos Programados</h3>

<div class="card">
  <div class="box-informacoes">
    <span class="botao-acessar-cor-1">Feira de Ciências</span>
    <p class="detalhes-evento mt-3">
      Data: 22/07/2025 • Auditório Principal
    </p>
  </div>
  <button class="botao-acessar-cor-1">Ver Detalhes</button>
</div>

<div class="card">
  <div class="box-informacoes">
    <span class="botao-acessar-cor-2">Reunião de Pais e Mestres</span>
    <p class="detalhes-evento mt-3">
      Data: 25/07/2025 • Sala dos Professores
    </p>
  </div>
  <button class="botao-acessar-cor-2">Ver Detalhes</button>
</div>

<div class="card">
  <div class="box-informacoes">
    <span class="botao-acessar-cor-3">Apresentação Cultural</span>
    <p class="detalhes-evento mt-3">
      Data: 30/07/2025 • Ginásio Poliesportivo
    </p>
  </div>
  <button class="botao-acessar-cor-3">Ver Detalhes</button>
</div>
